<template>
  <HomeHeader1 />
  <HomeHeader2 />
  <HomeBody1 />
  <HomeBody2 />
  <HomeBody3 />
  <HomeBody4 />
  <HomeFooter />
</template>

<script>
import HomeHeader1 from '../molecules/HomeHeader1.vue'
import HomeHeader2 from '../molecules/HomeHeader2.vue'
import HomeBody1 from '../molecules/HomeBody1.vue'
import HomeBody2 from '../molecules/HomeBody2.vue'
import HomeBody3 from '../molecules/HomeBody3.vue'
import HomeBody4 from '../molecules/HomeBody4.vue'
import HomeFooter from '../molecules/HomeFooter.vue'

export default {
  name: 'HomeView',
  components: {
    HomeHeader1,
    HomeHeader2,
    HomeBody1,
    HomeBody2,
    HomeBody3,
    HomeBody4,
    HomeFooter,
  }
}
</script>
